class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.totalElements = 0;
        this.currentScroll = 1;
        this.barInterval = null;
        this.initSlider();
        this.resizeListener();
    }

    initSlider() {
        const { barMessage, sliderSettings } = this.barComponents();
        const totalSlides = barMessage.length;

        if(totalSlides > 1) {
            this.totalElements = totalSlides;
            this.barInterval = setInterval(() => {
                this.slideElements();
            }, Number(sliderSettings.dataset.speed) * 1000 );
        }
    }

    resizeListener() {
        window.addEventListener('resize', () => {
            this.resetBarScrolling();
        });
    }

    slideElements() {
        const { mainContainer } = this.barComponents();

        const singleMessage = mainContainer.querySelector('.bar-message');
        const messageTotalWidth = singleMessage.clientWidth;

        mainContainer.scrollTo({
            top: 100,
            left: messageTotalWidth * this.currentScroll,
            behavior: 'smooth'
        })
        this.currentScroll++;
        this.checkScrollBack();
    }
    
    checkScrollBack() {
        if(this.currentScroll == this.totalElements + 1) {
            this.resetBarScrolling();
        }
    }

    resetBarScrolling() {
        const { mainContainer } = this.barComponents();
        clearInterval(this.barInterval);
        this.currentScroll = 1;

        mainContainer.scrollTo({
            top: 100,
            left: 0,
            behavior: 'instant'
        })
        this.initSlider();
    }

    barComponents() {
        const mainContainer = this.querySelector('#announcement-bar-container');
        const barMessage = this.querySelectorAll('.bar-message');
        const sliderSettings = this.querySelector('.slider-settings');
        return { mainContainer, barMessage, sliderSettings };
    }
}

customElements.define('announcement-bar', AnnouncementBar);